var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H27.2C31.6804 0 33.9206 0 35.6319 0.871948C37.1372 1.63893 38.3611 2.86278 39.1281 4.36808C40 6.07937 40 8.31958 40 12.8V27.2C40 31.6804 40 33.9206 39.1281 35.6319C38.3611 37.1372 37.1372 38.3611 35.6319 39.1281C33.9206 40 31.6804 40 27.2 40H12.8C8.31958 40 6.07937 40 4.36808 39.1281C2.86278 38.3611 1.63893 37.1372 0.871948 35.6319C0 33.9206 0 31.6804 0 27.2V12.8Z",
    className: "backgroundHighlight"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.891 9.12864L16.9222 9.66739L12.5103 20.8575L19.3806 20.3939L15.617 29.5114L28.5119 16.1227L20.3008 16.5856L24.891 9.12864ZM25.7243 7.06773C26.9409 6.98548 27.7421 8.31219 27.1029 9.35062L24.0112 14.3733L29.6715 14.0541C31.0331 13.9774 31.7824 15.6101 30.8364 16.5923L15.23 32.7962C14.0812 33.9891 12.1312 32.7142 12.7631 31.1833L16.3037 22.6061L11.8562 22.9061C10.7571 22.9803 9.95569 21.8841 10.3597 20.8594L15.1776 8.63967C15.3901 8.10075 15.8939 7.73235 16.4719 7.69327L25.7243 7.06773Z",
    className: "textCallout"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.68c7dcf0aedeb35ee7761219a4c35b29.svg";
export { ForwardRef as ReactComponent };